module.exports = __webpack_public_path__ + "img/icon_5_79.f0a903b5.png";